import { createDeferredLoadable } from '../../utils/createDeferredLoadable';
export const LoadablePublicHubCreditsExplainer = createDeferredLoadable(() => import( /* webpackChunkName: "public-hub-credits-explainer" */'./PublicHubCreditsExplainer').then(m => ({
  default: m.default
})));